import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["link"]

  connect() {
    this.observer = new IntersectionObserver(
      (entries) => this.#onIntersect(entries),
      { rootMargin: "-80px 0px -60% 0px", threshold: 0 }
    )
    this.#observeSections()
  }

  disconnect() {
    this.observer?.disconnect()
  }

  toggle(event) {
    const sidebar = document.getElementById("toc")
    const overlay = document.querySelector(".toc-overlay")
    sidebar?.classList.toggle("toc-open")
    overlay?.classList.toggle("active")
  }

  close() {
    const sidebar = document.getElementById("toc")
    const overlay = document.querySelector(".toc-overlay")
    sidebar?.classList.remove("toc-open")
    overlay?.classList.remove("active")
  }

  #observeSections() {
    document.querySelectorAll("section[id], article[id]").forEach((el) => {
      this.observer.observe(el)
    })
  }

  #onIntersect(entries) {
    const visible = entries
      .filter((e) => e.isIntersecting)
      .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top)

    if (visible.length > 0) {
      const id = visible[0].target.id
      this.#activateLink(id)
    }
  }

  #activateLink(id) {
    this.linkTargets.forEach((link) => {
      const href = link.getAttribute("href")?.replace(/^#/, "")
      link.classList.toggle("toc-active", href === id)
    })
  }
}
